import styled, { css } from "styled-components";
import { border, color, typeStyle, units } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
export const ExpandableContent = styled.div `
  color: ${color("typeLink")};
  ${({ hasDivider }) => hasDivider &&
    css `
      border-top: ${border()};
    `};

  transition: all 0.1s ease-in;
`;
export const Toggle = styled(NakedButton) `
  color: ${color("typeLink")};
  display: flex;
  justify-content: flex-start;
  width: 100%;
  cursor: pointer;
  padding: ${units(1.5)} 0;
  ${typeStyle("bodyS")};

  > svg {
    margin: -1px ${units(0.5)} 0;
    transition: transform 0.1s ease-in;
    transform: scaleY(${({ isExpanded }) => (isExpanded ? "-1" : "1")});
  }
`;
export const Content = styled.div `
  overflow: hidden;
  color: ${color("typeBody")};

  padding: 0;
  display: none;

  ${({ isExpanded, hasContentDivider }) => isExpanded &&
    css `
      padding: 0 ${units(3)};
      display: unset;

      ${hasContentDivider && `border-top: 1px solid #ced4da;`}
    `};
`;
